module.exports = __webpack_public_path__ + "static/img/room_back.2166a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room_back.png
// module id = rA1u
// module chunks = 0